
import Privacy from '@/components/shared/Privacy.vue'
import Cookie from '@/components/shared/Cookie.vue'
import { Component, Vue } from 'vue-property-decorator'

	@Component({
	  name: 'PrivacyBanner',
	  components: {
	    Cookie,
	    Privacy
	  }
	})
export default class PrivacyBanner extends Vue {
		isPrivacyVisible = false
		isCookieVisible = false

		showModal (modal: string) {
		  if (modal === 'Privacy') {
		    this.isPrivacyVisible = true
		    this.isCookieVisible = false
		    return
		  }

		  this.isPrivacyVisible = false
		  this.isCookieVisible = true
		}

		closeModal () {
		  this.isCookieVisible = false
		  this.isPrivacyVisible = false
		}
}
